/**
 *
 * ConvertImage
 *
 */

import ConvertImage from './ConvertImage/index';
export default ConvertImage;



// WEBPACK FOOTER //
// ./src/index.js